import { TCreatorApplicationProfile } from '@/types/CreatorApplication.types';
import { displayCapitalizedUnderscoredString } from '@/utils/stringUtils';
import { Center, Image, Text, VStack } from '@chakra-ui/react';
import React, { useState } from 'react';
import { InfoRow, SectionCard } from './SectionLayout';
import colors from '@/theme/colors';

interface Props {
  profile: TCreatorApplicationProfile;
}

const formatLocation = (location?: { city?: string; state?: string; zip?: string }): string => {
  if (!location) return '/';
  const parts = [location.city, location.state, location.zip].filter(Boolean);
  return parts.length ? parts.join(', ') : '/';
};

const ProfileTab = ({ profile }: Props) => {
  // Photo is served via a signed URL that can expire — fall back to a placeholder on error.
  const [photoFailed, setPhotoFailed] = useState(false);

  return (
    <VStack align="stretch" width="100%" gap="20px">
      <SectionCard title="Profile">
        {profile?.photoUrl && !photoFailed ? (
          <Image
            src={profile.photoUrl}
            alt="Applicant photo"
            borderRadius="8px"
            objectFit="cover"
            boxSize="140px"
            alignSelf="center"
            onError={() => setPhotoFailed(true)}
          />
        ) : (
          <Center boxSize="140px" alignSelf="center" borderRadius="8px" backgroundColor="background.lightGray">
            <Text color="text.mediumGray" fontSize="14px">
              No photo
            </Text>
          </Center>
        )}
        <InfoRow label="Location">{formatLocation(profile?.location)}</InfoRow>
        <InfoRow label="Certifications">
          {profile?.certifications?.length ? profile.certifications.join(', ') : '/'}
        </InfoRow>
        <InfoRow label="Content focus">
          {profile?.contentFocus?.length
            ? profile.contentFocus.map((focus) => displayCapitalizedUnderscoredString(focus)).join(', ')
            : '/'}
        </InfoRow>
        <VStack width={'100%'} alignItems={'start'}>
          <Text color={colors.text.mediumGray} fontWeight={600} minWidth="160px">
            Bio
          </Text>
          <Text maxWidth={'100%'}>{profile?.bio || '/'}</Text>
        </VStack>
      </SectionCard>
    </VStack>
  );
};

export default ProfileTab;
